import React from "react";

const UserIcon = () => {
  return (
    <svg className="icon icon--user " width="30" height="25">
      <use
        xlinkHref={`${$(
          "#STATIC_ASSETS_URL"
        ).val()}/images/sprites/symbol/sprite.svg#user`}
      ></use>
    </svg>
  );
};

export default UserIcon;
